import React from "react";
import JotFormReact from "jotform-react";
import contactUsBg from "../../assets/images/contactusBg.svg";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { options } from "../../utils/richTextOptions";

const CareerForm = ({ title, description }) => {
  return (
    <div className="bg-[#f2f2f2] relative">
      <div
        className="absolute contents-[''] top-0 right-0 w-full h-full -scale-x-100 bg-no-repeat bg-cover z-0"
        style={{ backgroundImage: `url(${contactUsBg})` }}
      ></div>
      <div className="relative py-[68px] md:py-[90px] box-border z-[1]">
        <div className="px-5 xl:px-[90px]">
          <div className="max-w-6xl w-full mx-auto pb-10">
            {description && (
              <div className="mb-[30px]">
                <div className="max-w-[700px] mt-5 text-[15px] md:text-base">
                  {documentToReactComponents(
                    JSON.parse(description.raw),
                    options
                  )}
                </div>
              </div>
            )}
            <JotFormReact
              formURL="https://form.jotform.com/220926950616863"
              autoResize={true}
              formID="220926950616863"
              initialHeight={300}
              heightOffset={30}
              allowFullScreen={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerForm;
